import {
  BackButton,
  PageTitle,
} from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import { Team, useTeam } from '@foxtrotplatform/platform-micro-site-core';
import {
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHeader,
  TableRow,
} from '@windmill/react-ui';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { UserTeamComponent } from './UserTeam';

export const UserTeamTable: React.FunctionComponent =
  (): JSX.Element | null => {
    const navigate = useNavigate();
    const { teams, setCurrentTeam } = useTeam();
    const [pageTable, setPageTable] = useState(1);
    const [dataTable, setDataTable] = useState<Team[]>([]);
    const resultsPerPage = 5;
    useEffect(() => {
      if (teams) {
        setDataTable(
          teams.slice(
            (pageTable - 1) * resultsPerPage,
            pageTable * resultsPerPage
          )
        );
      }
    }, [pageTable, teams]);

    const onPageChange = (pageNumber: number) => {
      setPageTable(pageNumber);
    };

    const redirectToTeamManagement = async (teamId: string) => {
      const newTeam = teams?.find(({ id }) => id === teamId);
      if (newTeam) {
        await setCurrentTeam(newTeam);
        navigate(`/team/${teamId}/management`);
      }
    };

    const mapMembers = () => {
      return (
        <TableBody>
          {dataTable.map((team) => {
            return (
              <UserTeamComponent
                key={`${team.id}`}
                redirectToTeamManagement={redirectToTeamManagement}
                team={team}
              />
            );
          })}
        </TableBody>
      );
    };

    if (!teams || !dataTable || dataTable.length <= 0) {
      return null;
    }

    return (
      <div className="mb-os1-spacing">
        <div className="flex flex-row items-center gap-x-3 mb-os1-spacing">
          <BackButton />
          <PageTitle>Your Teams</PageTitle>
        </div>
        <TableContainer>
          <Table>
            <TableHeader>
              <TableRow>
                <TableCell>Team Name</TableCell>
                <TableCell>Your Role</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHeader>
            {mapMembers()}
          </Table>
          <TableFooter>
            <Pagination
              label="Table navigation"
              onChange={onPageChange}
              resultsPerPage={resultsPerPage}
              totalResults={teams?.length}
            />
          </TableFooter>
        </TableContainer>
      </div>
    );
  };
